function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("WhiteBox creates a unified profile for each individual, connected to your business. WhiteBox combines their full online and offline journey, unleashing the possibilities to measure success indicators within your online sales funnel.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("WhiteBox detects inquiries via phone and web forms coming from your website.")]),_vm._v(" "),_c('li',[_vm._v("WhiteBox attributes these inquiries to the exact user that came from Google AdWords, Facebook Ads, PR and other online marketing source.")]),_vm._v(" "),_c('li',[_vm._v("WhiteBox integrates with your customer relations database, so it could deliver insights about real bottom line results of your business coming from online inquiries.")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/details","summary":"What is WhiteBox?"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }